<div *ngIf="mask" class="lmask" [style.background-color]="color"></div>